import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import LoupeTextFieldComponent from './LoupeTextFieldComponent';
import LoupeSelectionComponent from './LoupeSelectionComponent';
import LoupeChipComponent from './LoupeChipComponent';
import LoupeLikertItemSelectionComponent from './LoupeLikertItemSelectionComponent';
import LoupeLikerMultipletItemSelectionComponent from './LoupeLikertItemMultipleSelectionComponent';
import LoupeLikertItemSliderComponent from './LoupeLikertItemSliderComponent';
import LoupeMappingSimpleMarkerMapComponent from './LoupeMappingSimpleMarkerMapComponent';
import LoupeMappingDraggableMarkerMapComponent from './LoupeMappingDraggableMarkerMapComponent';
import LoupeCameraComponent from './LoupeCameraComponent';
import LoupeNumericRangeSelectionComponent from './LoupeNumericRangeSelectionComponent';
import LoupeChipConditionalLikertItem from './LoupeChipConditionalLikertItem';
import LoupeChipConditionalSliderItem from './LoupeChipConditionalSliderItem';
import LoupeChipConditionalChipsItem from './LoupeChipConditionalChipsItem';
import LoupeSoundMeteringComponent from './LoupeSoundMeteringComponent';

import Button from '@mui/material/Button';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';

import LoupeValidationEngine from '../LoupeValidationEngine';
import Alert from '@mui/material/Alert';
import { LocalizationContext } from '../../App';

// remove the following once proper component refacotring completed
import { MapContainer, TileLayer, Marker, Popup, Circle, Polygon, MapConsumer, useMapEvents } from 'react-leaflet';
import * as Leaflet from 'leaflet';
import Form from 'react-bootstrap/Form';
import { Navigate } from 'react-router-dom';




const LoupeActivityItem = props => {

    const navigate = useNavigate();


    const currentItem = props.currentItem;


    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    })

    // validation tools
    const [ isValid, setIsValid ] = useState(currentItem.validator.validationState);
    const [ isMounted, setIsMounted ] = useState(null);
    const [ brokenRules, setBrokenRules ] = useState(currentItem.validator.getBrokenRules());

    const onError = () => {
        if(isMounted) {
            setIsValid(false);
            setBrokenRules(currentItem.validator.getBrokenRules());
        }
    }
    const onSuccess = () => {
        if(isMounted) {
            setIsValid(true);
        }
    }    

    currentItem.validator.setOnErrorHandler(onError);
    currentItem.validator.setOnSuccessHandler(onSuccess);


    useEffect(() => {
        setIsMounted(true);

        return function cleanup() {
            setIsMounted(false);
        }
    }, []);

    return(

        <LocalizationContext.Consumer>

            { ({strings}) =>

                <div className={"padcontent" + ( isValid == false ? ' mdc-error' : '')}>
                
                    { currentItem.type == 'title' &&                          
                        <Typography variant="h4" className="text-start" gutterBottom component="div">{currentItem.label}</Typography>                        
                    }

                    { currentItem.type == 'label' &&                          
                        <Typography variant="subtitle2" className="text-start" gutterBottom component="div">{currentItem.label}</Typography>                        
                    }

                    { currentItem.type == 'image' &&
                        <div className="mb-4" style={{ maxWidth: isMobileView ? '90vw': '90%'}}>

                            <Typography variant="h6" className="text-start mb-4" gutterBottom component="div">{currentItem.label}</Typography>                        
                            <Grid container>

                                <Grid item md/>

                                <Grid item md={6} xs={12}>
                                    <img width="100%" className="mb-2" src={process.env.REACT_APP_SERVICE_URI + '/resources/images/' + currentItem.imageSource} />
                                    <Typography variant="caption" gutterBottom component="div">{currentItem.caption}</Typography>
                                </Grid>

                                <Grid item md/>

                            </Grid>
                            
                            
                        </div>

                    }

                    { currentItem.type == "numeric-range" &&
                        <LoupeNumericRangeSelectionComponent currentItem={currentItem} />
                    }

                    { currentItem.type == "text" && 
                        <LoupeTextFieldComponent currentItem={currentItem} />                            
                    }

                    { currentItem.type == "chips" &&                                                                                                                                
                        <LoupeChipComponent currentItem={currentItem} />                                           
                    }

                    { currentItem.type == "selection" && 
                        <LoupeSelectionComponent currentItem={currentItem} />
                    }

                    { currentItem.type == "likert-selection" &&  
                        <LoupeLikertItemSelectionComponent currentItem={currentItem}/>                                           
                    }

                    { currentItem.type == "likert-multiselection" &&  
                        <LoupeLikerMultipletItemSelectionComponent currentItem={currentItem}/>                                           
                    }

                    { currentItem.type == "likert-slider" && 
                        <LoupeLikertItemSliderComponent currentItem={currentItem} />
                    }

                    { currentItem.type == "simple-map" &&                         
                        <LoupeMappingSimpleMarkerMapComponent currentItem={currentItem}/>                        
                    }

                    { currentItem.type == "draggable-map" && 
                        <LoupeMappingDraggableMarkerMapComponent currentItem={currentItem} />                                                                                        
                    }

                    { currentItem.type == "camera-image" && 
                        <LoupeCameraComponent currentItem={currentItem} />
                    }

                    { currentItem.type == "chip-conditional-likert" && 
                        <LoupeChipConditionalLikertItem currentItem={currentItem} />
                    }

                    { currentItem.type == "chip-conditional-slider" &&                    
                        <LoupeChipConditionalSliderItem currentItem={currentItem} />
                    }

                    { currentItem.type == "chip-conditional-chips" &&                    
                        <LoupeChipConditionalChipsItem currentItem={currentItem} />
                    }

                    { currentItem.type == "sound-metering" &&                    
                        <LoupeSoundMeteringComponent currentItem={currentItem} />
                    }

                    { !isValid && 
                        <div>
                            { brokenRules.map(r => {
                                
                                return(
                                    <Alert key={r.label} severity="error" className="padtop">{strings.formatString(strings.getString(r.label), r.value)}</Alert>
                                );
                                }) 
                        
                            }
                        </div>
                    }


                </div>
            }
        </LocalizationContext.Consumer>
    );


}
export default LoupeActivityItem;